<template>
  <div>
    <campaign-list :tableColumns="tableColumns" :params="params" :addBtnShow="addBtnControl" />
  </div>
</template>

<script>
import CampaignList from '../campaign/Links.vue';

export default {
  name: 'WebPushList',
  components: {
    CampaignList,
  },
  data() {
    return {
      tableColumns: [
        { key: 'id', sortable: true },
        { key: 'campaign_name', label: 'Paylaşım', sortable: true },
        { key: 'description', label: 'Mesaj İçeriği', sortable: false },
        { key: 'event_count', label: 'Ziyaret', sortable: false },
        { key: 'cart_count', label: 'Sepete Ekleme', sortable: false },
        { key: 'order_count', label: 'Sipariş Adedi', sortable: false },
        { key: 'total_amount', label: 'Sipariş Tutarı', sortable: false },
        { key: 'status', label: 'Durum' },
        { key: 'actions', label: 'Detay' },
      ],
      params: {
        filter: {
          type: 6, // WebPush için type 6
        },
        source: 'list',
      },
    };
  },
  computed: {
    addBtnControl() {
      return this.$store.state.user.userData.permissions?.includes('firma_paylasimi.webpush_ekleyebilir_duzenleyebilir');
    },
  },
};
</script>
